import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ButtonBase } from '@mui/material';
import { faArrowRightFromBracket } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { urlMap } from 'routes/urlMap';
import {
  storageEngine, RAILS_APP_HOST_KEY, TOKEN_KEY, IS_FRAMED, getRailsUrl
} from 'utilities/integration/rails';
import getText from 'context/language/getText';
import { clearAdminToken } from 'utilities/auth/adminToken';
import { getUser } from 'selectors';
import { clearUserSession, clearFeatureUserSettings } from 'actions';
import { useDataMutation } from 'hooks';
import {
  NavLinkItem,
  NavLinkIconContainer,
  NavLinkSubText,
} from '../components/styled';
import { destroyUserSession } from '../graphql';

export const LogoutLink = () => {
  const user = useSelector(getUser);
  const history = useHistory();
  const dispatch = useDispatch();
  const [_signOutRes, executeSignOut] = useDataMutation(destroyUserSession);

  const handleLogout = () => {
    dispatch(clearFeatureUserSettings());
    clearAdminToken();
    const railsHost = storageEngine.getItem(RAILS_APP_HOST_KEY);
    window.parent.postMessage({ context: 'logoutUser' }, railsHost);
  };

  return (
    <NavLinkItem>
      <ButtonBase onClick={handleLogout} data-test-id="sidenav__button-logout">
        <NavLinkIconContainer>
          <FontAwesomeIcon icon={faArrowRightFromBracket} />
        </NavLinkIconContainer>
        <div style={{ textAlign: 'left', marginLeft: '8px' }}>
          {getText('navbar.logout')}
          <NavLinkSubText>{user.email}</NavLinkSubText>
        </div>
      </ButtonBase>
    </NavLinkItem>
  );
};
